import {
  Heading,
  RadioGroup,
  RadioItem,
  Stack,
  Text,
} from 'braid-design-system';

import type { UserRegistrationType } from 'src/types/userRegistrationType';

interface UserTypeProps {
  valid: boolean;
  errorMessage: string;
  onChange: (value: UserRegistrationType) => void;
  value: string;
}

const UserType = ({ valid, errorMessage, onChange, value }: UserTypeProps) => (
  <Stack space="large">
    <Stack space="small">
      <Heading level="3" component="h2" id={userRegistrationTypeLabelId}>
        What do you plan to use SEEK Business for?
      </Heading>
      <Text>
        We use this information to give you a personalised experience.
      </Text>
    </Stack>
    <RadioGroup
      id="userRegistrationType"
      aria-labelledby={userRegistrationTypeLabelId}
      required
      onChange={(ev) =>
        onChange(ev.currentTarget.value as UserRegistrationType)
      }
      value={value}
      tone={valid ? 'neutral' : 'critical'}
      message={!valid && errorMessage}
    >
      <RadioItem
        label="Buying a business"
        value="Buyer"
        data={{ testid: 'Buyer' }}
      />
      <RadioItem
        label="Selling my business"
        value="PrivateSeller"
        data={{ testid: 'PrivateSeller' }}
      />
      <RadioItem
        label="I'm a business broker"
        value="Broker"
        data={{ testid: 'Broker' }}
      />
      <RadioItem
        label="I'm a real estate agent"
        value="RealEstateAgent"
        data={{ testid: 'RealEstateAgent' }}
      />
      <RadioItem
        label="I'm a franchisor"
        value="Franchisor"
        data={{ testid: 'Franchisor' }}
      />
      <RadioItem
        label="I'm a licensor / distributor"
        value="LicensorOrDistributor"
        data={{ testid: 'LicensorOrDistributor' }}
      />
    </RadioGroup>
  </Stack>
);

const userRegistrationTypeLabelId = 'onboarding-user-registration-type-label';

export default UserType;
